export const CLOCKING_DIALOG_MODE = {
  ENTRY: 'entry',
  TODAY: 'today',
} as const

// Temporarily hidden for the current release. Set to true to restore the
// desktop/mobile clocking controls and timeline clocking editor.
export const CLOCKING_UI_ENABLED = false
